/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'

if (environment.production) {
  const methods = ['log', 'debug', 'info', 'warn'] as const satisfies readonly (keyof Console)[]

  methods.forEach((method) => {
    console[method] = () => undefined
  })
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))
